var error = {};
		error['otpsubmit'] = "otpSubmit";
		error['otpVerify'] = "otpVerify";
		error['otpVerifylogin'] = "otpVerifylogin";
		error['otpResend'] = "otpResend";
		error['anonymousUser'] = "anonymousUser";
		error['formType'] = "auto";

window.onerror = function(message, file, line, column, error) {
				//stackTrace()
			error = error || {};
			var data = {
					message: message,
					file: file,
					line: line,
					column: column,
					
				}
				if(window.page){
					data.error =  {
						name: error.name,
						message: error.message,
						stack: error.stack
					}  
				}
				let jsonString = JSON.stringify(data)
}
export const errorTrack = (page,errorLevel,apiError,reqSource='')=>{
	window._gaq = window._gaq || [];
	if(page === 'PapMsite'){
		window._gaq.push(['_trackEvent', 'QH-Errors', page, `${reqSource}_${errorLevel}_${apiError}`,0,true]);
	}else{
		window._gaq.push(['_trackEvent', 'QH-Errors', page, `${error.formType}_${reqSource}_${errorLevel}`,0,true]);
	}
	
	
	//apiError = JSON.stringify(apiError)
}